<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <h2>{{translate?.general.buttons.select2.singular}} {{translate?.jobOrder.label.singular}} {{translate?.setup.modules.templates.label.plural}}</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular" (click)="closeTable()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body pt-0"> 
        <div class="template-picker">
            <!-- Left panel: categories -->
            <aside class="tp-left" role="tablist" aria-label="Template categories">
                <div class="tp-left__header">
                    <h3>{{translate?.jobOrder.label.singular}} {{translate?.setup.modules.types.label.plural}}</h3>
                </div>
                <!-- job order types -->
                <div class="tp-left__list">
                    <button
                        *ngFor="let jotype of jobOrderTypes;"
                        type="button"
                        class="tp-cat"
                        role="tab"
                        [attr.aria-selected]="jotype.id === activeCatId"
                        [class.is-active]="jotype.id === activeCatId"
                        (click)="setCategory(jotype.id)"
                        >
                        <!-- <span class="tp-cat__icon">
                            <i class="fa-regular fa-screwdriver-wrench"></i>
                        </span> -->
                        <span class="tp-cat__icon " [ngClass]="jotype?.icon+'-bgColor'">
                            <i class="fa-regular {{ jotype?.icon }}"></i>
                        </span>
                        
                        <span class="tp-cat__label">{{ jotype.label }}</span>
                        <span class="tp-cat__count">{{ jotype.jobOrderTmplCount ? jotype.jobOrderTmplCount : 0 }}</span>
                    </button>
                </div>

                <button *ngIf="displayNewTmplButton" type="button" class="tp-new-template" (click)="createNewTemplate()">
                    <i class="fa-regular fa-plus me-2"></i>
                    {{translate?.general.buttons.new.singular}} {{translate?.setup.modules.templates.label.singular}}
                </button>
            </aside>

            <!-- Right panel: search + list -->
            <section class="tp-right">
                <header class="tp-right__header">
                <!-- <h3 *ngIf="!loadFrom || loadFrom !== 'JO'">Create job order from template</h3> -->
                 <h3 *ngIf="loadFrom == 'Plan'">{{translate?.general.buttons.select2.singular}} {{translate?.jobOrder.label.singular}} template for your maintenance</h3>
                <p>Pick {{translate?.general.messages.aLower}} {{translate?.setup.modules.templates.label.singular | lowercase}} to quickly {{translate?.general.buttons.create.singular}} {{translate?.general.messages.aLower}} {{translate?.jobOrder.label.singular}} with pre-filled details.</p>

                <span class="p-input-icon-left w-100 py-2">
                    <i class="pi pi-search"></i>
                    <input
                    type="text"
                    pInputText
                    [(ngModel)]="searchValue"
                    placeholder="{{translate?.general.buttons.search.singular}} {{translate?.setup.modules.templates.label.plural | lowercase}}"
                    (keyup)="quickSearch()"
                    aria-label="Search templates"
                    />
                </span>
                </header>

                <div class="tp-list tp-list--grouped" role="listbox" [attr.aria-multiselectable]="false" (scroll)="onScroll($event)">
                <button
                    *ngFor="let t of templates;"
                    type="button"
                    class="tp-row"
                    role="option"
                    [attr.aria-selected]="selectedJOT?.id === t.id"
                    [class.is-active]="selectedJOT?.id === t.id"
                    (click)="selectItem(t)"
                >
                    <!-- <span class="icon" [style.--pill]="t.bg" [style.--pillIcon]="t.fg">
                     <i class="fa-regular fa-screwdriver-wrench"></i>
                    </span> -->
                    <span class="icon" [ngClass]="t?.joTypeObject?.icon ? t?.joTypeObject?.icon+'-bgColor' : 'fa-screwdriver-wrench'">
                            <i class="fa-regular {{ t?.joTypeObject?.icon }}"></i>
                        </span>


                    <div class="meta">
                    <div class="meta-title">{{ t.templateName }}</div>
                    <!-- <div class="desc">{{ t.desc }}</div> -->
                    </div>

                    <span *ngIf="t.jobOrderType" class="status-pill">{{ t.jobOrderType?.label }}</span>
                </button>

                <!-- <div class="tp-empty" *ngIf="filteredTemplates().length === 0">
                    No templates found.
                </div> -->
                </div>

                 <!-- <div class="tp-right__footer">
                    <p-button type="button" [label]="translate?.general.buttons.next.singular" styleClass="action" (onClick)="nextCreate()"></p-button>
                </div> -->
            </section>
        </div>
    </div>
</div>